import _ from 'lodash';
import moment from 'moment';
var getYearAry = function (m) {
    return _.map(m, function (v) { return [
        moment(v['yearFrom'], 'YYYY'),
        !_.isNull(v['yearTo']) ? moment(v['yearTo'], 'YYYY') : moment(),
    ]; });
};
var iterationYear = function (result, value) {
    if (_.isEmpty(result)) {
        result = value;
        return result;
    }
    if (result[0].isAfter(value[0])) {
        result[0] = value[0];
    }
    if (result[1].isBefore(value[1])) {
        result[1] = value[1];
    }
    return result;
};
var getDaysBetweenDates = function (range) {
    var dates = [];
    if (!_.isEmpty(range)) {
        var now = range[0].clone();
        while (now.isSameOrBefore(range[1])) {
            dates.push(now.format('YYYY'));
            now.add(1, 'years');
        }
    }
    return dates;
};
var analyseData = {
    vehicleType: function (vehicleTypes) {
        return _.chain(vehicleTypes)
            .map(function (v) { return v.name; })
            .uniq()
            .value();
    },
    make: function (vehicleTypes, vehicleType) {
        if (_.isEmpty(vehicleTypes)) {
            return [];
        }
        return _.chain(vehicleTypes)
            .cloneDeep()
            .find(['name', vehicleType])
            .thru(function (d) { return d['make']; })
            .thru(function (d) { return _.map(d, 'name'); })
            .value();
    },
    model: function (vehicleTypes, vehicleType, make) {
        if (_.isEmpty(make)) {
            var result = _.chain(vehicleTypes)
                .filter(function (item) { return _.isEmpty(vehicleType) || item.name === vehicleType; })
                .map(function (v) { return _.map(v['make'], function (item) { return item['model']; }); })
                .value();
            return _.uniq(_.flatMapDeep(result));
        }
        else {
            var result = _.chain(vehicleTypes)
                .filter(function (item) { return _.isEmpty(vehicleType) || item.name === vehicleType; })
                .map(function (v) {
                return _.map(v['make'], function (item) {
                    if (_.isEqual(item['name'], make)) {
                        return item['model'];
                    }
                    else {
                        return [];
                    }
                });
            })
                .value();
            return _.uniq(_.flatMapDeep(result));
        }
    },
    year: function (models) {
        var yearsAry = getYearAry(models);
        var range = _.reduce(yearsAry, iterationYear, []);
        return getDaysBetweenDates(range);
    },
    vehicleTypeFormat: function (vehicles) {
        return _.chain(vehicles)
            .map(function (v) { return v.vehicleType; })
            .uniq()
            .map(function (v) {
            return { name: v };
        })
            .thru(function (v) {
            return _.chain(v)
                .map(function (vehicleItem) {
                return _.update(vehicleItem, 'make', function () {
                    return _.chain(vehicles)
                        .filter(['vehicleType', vehicleItem['name']])
                        .map(function (v) { return v.make; })
                        .uniq()
                        .map(function (v) {
                        return { name: v };
                    })
                        .thru(function (v) {
                        return _.chain(v)
                            .map(function (_v) {
                            return _.update(_v, 'model', function () {
                                return _.chain(vehicles)
                                    .filter(['vehicleType', vehicleItem['name']])
                                    .filter(['make', _v['name']])
                                    .map(function (v) { return v.model; })
                                    .uniq()
                                    .value();
                            });
                        })
                            .value();
                    })
                        .value();
                });
            })
                .value();
        })
            .value();
    },
    getMake: function (vehicleTypes) {
        return _.chain(vehicleTypes)
            .reduce(function (result, vehicleType) {
            var makes = vehicleType['make'];
            var r = _.chain(makes)
                .reduce(function (_result, make) {
                return _.concat(_result, make['name']);
            }, [])
                .value();
            return _.concat(result, r);
        }, [])
            .uniq()
            .value();
    },
    getYear: function (vehicles) {
        var yearsAry = getYearAry(vehicles);
        var range = _.reduce(yearsAry, iterationYear, []);
        return getDaysBetweenDates(range);
    },
};
export default analyseData;
